{
  "name": "pixelmanipulator",
  "version": "5.5.10",
  "description": "A super powerful Typescript library for cellular automation.",
  "main": "dist/main.js",
  "browser": "dist/browser.js",
  "module": "dist/module.js",
  "types": "dist/types.d.ts",
  "unpkg": "dist/bundle.js",
  "targets": {
    "main": {
      "source": "./src/pixelmanipulator.ts"
    },
    "module": {
      "source": "src/pixelmanipulator.ts"
    },
    "browser": {
      "source": "src/pixelmanipulator.ts",
      "outputFormat": "commonjs"
    },
    "types": {
      "source": "src/pixelmanipulator.ts"
    }
  },
  "repository": "git@github.com:Lazerbeak12345/pixelmanipulator.git",
  "homepage": "https://lazerbeak12345.github.io/pixelmanipulator",
  "author": "Nathan Fritzler <nfblaster@live.com>",
  "license": "GPL-3.0-or-later",
  "browserslist": "defaults",
  "keywords": [
    "cellular automata",
    "game of life",
    "highlife",
    "brians-brain",
    "wireworld",
    "wolfram",
    "rule-30",
    "rule-90",
    "rule-110",
    "rule-184",
    "conway",
    "pixel",
    "game",
    "life",
    "cellular",
    "automata",
    "automaton",
    "gameoflife",
    "gol",
    "brian's-brain",
    "particle",
    "simulation",
    "engine",
    "grid",
    "canvas"
  ],
  "devDependencies": {
    "@fast-check/ava": "catalog:",
    "@parcel/packager-ts": "catalog:",
    "@parcel/transformer-typescript-types": "catalog:",
    "@rollup/plugin-commonjs": "catalog:",
    "@types/eslint": "catalog:",
    "@types/node": "catalog:",
    "@typescript-eslint/eslint-plugin": "catalog:",
    "@typescript-eslint/parser": "catalog:",
    "ava": "catalog:",
    "c8": "catalog:",
    "eslint": "catalog:",
    "eslint-config-love": "catalog:",
    "eslint-plugin-node": "catalog:",
    "eslint-plugin-promise": "catalog:",
    "eslint-plugin-tsdoc": "catalog:",
    "fast-check": "catalog:",
    "gh-pages": "^6.2.0",
    "parcel": "catalog:",
    "rollup": "catalog:",
    "typedoc": "catalog:",
    "typedoc-plugin-mdn-links": "catalog:",
    "typescript": "catalog:"
  },
  "scripts": {
    "test": "pnpm run test:types && pnpm run lint && pnpm run test:test",
    "test:types": "rm -r build; tsc --outDir build",
    "lint": "eslint . --ignore-pattern dist --ignore-pattern docs --ignore-pattern coverage --ignore-pattern build",
    "test:test": "c8 -r text -r text-summary -r lcov -r html --all --include build/src ava",
    "build": "pnpm t && pnpm run build:docs && pnpm run build:parcel && pnpm build:readme && pnpm run build:bundle && pnpm run build:prepare-ci",
    "build:docs": "typedoc --name PixelManipulator --out docs --includeVersion src/*.ts",
    "build:parcel": "parcel build",
    "build:readme": "cp ../../README.md .",
    "build:bundle": "rollup -c",
    "build:prepare-ci": "cp -r ../../.circleci docs && cp -r ../../media/* docs",
    "watch": "parcel watch --no-hmr",
    "updatedemo": "gh-pages -d docs -m \"Update $npm_package_version\" -tf"
  },
  "ava": {
    "timeout": "20s"
  },
  "packageManager": "pnpm@9.15.1"
}
